import "./scorecardSubscribe.css";
import "../../index.css";
import "./ScorecardHome/scorecardHome.css";
import ScorecardHomeSubHeader from "./ScorecardHome/scorecardHomeSubHeader";
import EmbeddedFormModal from "../../popUpForms/formModals/embeddedFormModal";
import EmbeddedFormScorecardSubscribePage from "../../popUpForms/embeddedFormScorecardSubscribePage";

const ScorecardSubscribe = ({ onSuccess, onError }) => {
  return (
    <>
      <ScorecardHomeSubHeader />
      <div className="scorecard-subscribe">
        <h2>Subscribe for Updates!</h2>
        <EmbeddedFormModal>
          <EmbeddedFormScorecardSubscribePage />
        </EmbeddedFormModal>
      </div>
    </>
  );
};

export default ScorecardSubscribe;
